/**
 * Mobile Bottom Navigation - App-like UX
 * Handles: active state detection, cart badge updates
 */
(function () {
  'use strict';

  var nav = document.getElementById('MobileBottomNav');
  if (!nav) return;

  /* ---- Add body class for CSS header overrides ---- */
  document.body.classList.add('mobile-app-nav-active');

  /* ---- Active state ---- */
  var items = nav.querySelectorAll('[data-nav-item]');
  var currentPath = window.location.pathname;

  /* Normalize: strip trailing slash except root */
  function normalizePath(p) {
    if (p.length > 1 && p.charAt(p.length - 1) === '/') {
      return p.slice(0, -1);
    }
    return p;
  }

  currentPath = normalizePath(currentPath);

  items.forEach(function (item) {
    var navPath = normalizePath(item.getAttribute('data-nav-path') || '');

    /* Exact match for home, prefix match for others */
    var isActive = false;
    if (navPath === '/') {
      isActive = currentPath === '/';
    } else if (navPath) {
      isActive = currentPath === navPath || currentPath.indexOf(navPath + '/') === 0;
    }

    if (isActive) {
      item.classList.add('is-active');
    }
  });

  /* ---- Cart badge ---- */
  var badge = document.getElementById('MobileNavCartBadge');

  function updateBadge(count) {
    if (!badge) return;
    var n = parseInt(count, 10) || 0;
    badge.textContent = n > 99 ? '99+' : n;
    badge.style.display = n > 0 ? '' : 'none';
  }

  /* Fetch cart count */
  function fetchCartCount() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBadge(cart.item_count); })
      .catch(function () { /* silent */ });
  }

  /* Initial load */
  fetchCartCount();

  /* Listen for custom cart events (from cart drawer, add-to-cart scripts) */
  document.addEventListener('cart:refresh', fetchCartCount);
  document.addEventListener('cart:updated', fetchCartCount);

  /* Intercept fetch to /cart/add.js, /cart/change.js, /cart/update.js */
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
      var result = origFetch.apply(this, arguments);

      if (
        urlStr.indexOf('/cart/add') !== -1 ||
        urlStr.indexOf('/cart/change') !== -1 ||
        urlStr.indexOf('/cart/update') !== -1 ||
        urlStr.indexOf('/cart/clear') !== -1
      ) {
        result.then(function () {
          /* Small delay to let Shopify update */
          setTimeout(fetchCartCount, 300);
        }).catch(function () { /* silent */ });
      }
      return result;
    };
  }

  /* Also intercept XMLHttpRequest for legacy scripts */
  var origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (
      typeof url === 'string' &&
      (url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1)
    ) {
      this.addEventListener('load', function () {
        setTimeout(fetchCartCount, 300);
      });
    }
    return origXHROpen.apply(this, arguments);
  };
})();
